// src/AuthContext.js
import React, { createContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { APP_NAME } from "./config";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [userId, setUserId] = useState(null);
  const [role, setRole] = useState(null);
  const [email, setEmail] = useState(null);
  const [fullname, setFullname] = useState(null);

  // Check cookies on mount
  useEffect(() => {
    const authCookie = Cookies.get(`${APP_NAME}_authenticated`);
    const uid = Cookies.get(`${APP_NAME}_userid`);
    if (authCookie === "true" && uid) {
      setAuthenticated(true);
      setUserId(uid);
    }
  }, []);

  const login = (user, rememberMe = false) => {
    // Set cookie expiration based on rememberMe
    const cookieOptions = rememberMe ? { expires: 30 } : undefined;

    console.log(user);

    // Save cookies
    Cookies.set(`${APP_NAME}_userid`, user.uid, cookieOptions);
    Cookies.set(`${APP_NAME}_role`, user.role, cookieOptions);
    Cookies.set(`${APP_NAME}_email`, user.email, cookieOptions);
    Cookies.set(`${APP_NAME}_fullname`, user.fullname, cookieOptions);
    Cookies.set(`${APP_NAME}_authenticated`, "true", cookieOptions);

    // Save email only if rememberMe is true
    if (rememberMe && user.email) {
      Cookies.set(`${APP_NAME}_email`, user.email, { expires: 30 });
    } else {
      Cookies.remove(`${APP_NAME}_email`);
    }

    // Update context state
    setRole(user.role);
    setUserId(user.uid);
    setEmail(user.email);
    setFullname(user.fullname);
    setAuthenticated(true);

    console.log(user);
  };

  const logout = () => {
    Cookies.remove(`${APP_NAME}_userid`);
    Cookies.remove(`${APP_NAME}_authenticated`);
    setUserId(null);
    setAuthenticated(false);
    setRole(null);
  };

  return (
    <AuthContext.Provider
      value={{ authenticated, userId, role, email, fullname, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
